module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticClass: "pull-right btn-information col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-information-save",
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-information-cancel",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('app-data-form', {
    ref: "form",
    attrs: {
      "withInitialData": ""
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-725a63a0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-725a63a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Information.vue
// module id = 483
// module chunks = 1